(function () {
  function initHowToBuy(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    var panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    function activateTab(tab, updateHash) {
      var name = tab.dataset.tab;
      tabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.panel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + name);
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activateTab(tab, true); });
      tab.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        var nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex], true);
      });
    });

    var hashTab = tabs.find(function (tab) { return '#' + tab.dataset.tab === window.location.hash; });
    if (hashTab) activateTab(hashTab, false);

    var stateSelect = root.querySelector('[data-dealer-state]');
    var typeSelect = root.querySelector('[data-dealer-type]');
    var list = root.querySelector('[data-dealer-list]');
    var pagination = root.querySelector('[data-dealer-pagination]');
    var empty = root.querySelector('[data-dealer-empty]');
    var dealersPanel = root.querySelector('[data-panel="dealers"]');
    var cards = Array.from(root.querySelectorAll('[data-dealer-card]'));
    var pageSize = 20;
    var currentPage = 1;
    var states = [
      ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
      ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'],
      ['DC', 'District of Columbia'], ['FL', 'Florida'], ['GA', 'Georgia'], ['HI', 'Hawaii'], ['ID', 'Idaho'],
      ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'], ['KS', 'Kansas'],
      ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'], ['MD', 'Maryland'],
      ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'],
      ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'], ['NV', 'Nevada'],
      ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'], ['NY', 'New York'],
      ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'],
      ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'], ['SC', 'South Carolina'],
      ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'], ['UT', 'Utah'],
      ['VT', 'Vermont'], ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'],
      ['WI', 'Wisconsin'], ['WY', 'Wyoming']
    ];

    function normalizeState(value) {
      var cleaned = (value || '').replace(/^\s*,\s*/, '').trim();
      var input = cleaned.toLowerCase();
      var match = states.find(function (state) {
        return state[0].toLowerCase() === input || state[1].toLowerCase() === input;
      });
      return match ? match[0] : cleaned.toUpperCase();
    }

    states.forEach(function (state) {
      var option = document.createElement('option');
      option.value = state[0];
      option.textContent = state[0] + ' — ' + state[1];
      stateSelect.appendChild(option);
    });

    function prepareCards(dealerCards) {
      dealerCards.forEach(function (card) {
        card.dataset.state = normalizeState(card.dataset.state);
      });
    }

    function getCardTypes(card) {
      return (card.dataset.types || '').split('|').map(function (type) {
        return type.trim();
      }).filter(Boolean);
    }

    var dealerTypeOrder = ['Pro Dealer', 'Plus Dealer', 'Distributor', 'Partner'];
    function populateDealerTypes() {
      var selectedType = typeSelect.value;
      typeSelect.options.length = 1;
      var dealerTypes = Array.from(new Set(cards.reduce(function (types, card) {
        return types.concat(getCardTypes(card));
      }, []))).sort(function (a, b) {
        var aIndex = dealerTypeOrder.indexOf(a);
        var bIndex = dealerTypeOrder.indexOf(b);
        if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });

      dealerTypes.forEach(function (type) {
        var option = document.createElement('option');
        option.value = type;
        option.textContent = type;
        typeSelect.appendChild(option);
      });
      if (dealerTypes.includes(selectedType)) typeSelect.value = selectedType;
    }

    function renderPagination(totalPages) {
      pagination.replaceChildren();
      pagination.hidden = totalPages <= 1;
      if (totalPages <= 1) return;

      function goToPage(page) {
        currentPage = page;
        renderDealers();
        dealersPanel.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }

      function addControl(page, direction) {
        var isPrevious = direction === 'previous';
        var arrow = document.createElement('span');
        arrow.className = 'animated-arrow' + (isPrevious ? ' animated-arrow--reverse' : '');
        if (page < 1 || page > totalPages) {
          var disabled = document.createElement('span');
          disabled.className = 'pagination__item pagination__item--disabled';
          disabled.appendChild(arrow);
          pagination.appendChild(disabled);
          return;
        }

        var link = document.createElement('a');
        link.className = 'pagination__item group';
        link.rel = isPrevious ? 'prev' : 'next';
        link.href = pageURL(page, pagination.dataset.pageParam || 'page');
        link.setAttribute('aria-label', 'Go to page ' + page);
        link.appendChild(arrow);
        link.addEventListener('click', function (event) {
          event.preventDefault();
          goToPage(page);
        });
        pagination.appendChild(link);
      }

      function addPage(page) {
        if (page === currentPage) {
          var current = document.createElement('span');
          current.className = 'pagination__item pagination__item--page pagination__item--current';
          current.setAttribute('aria-current', 'page');
          current.textContent = page;
          pagination.appendChild(current);
          return;
        }

        var link = document.createElement('a');
        link.className = 'pagination__item pagination__item--page group';
        link.href = pageURL(page, pagination.dataset.pageParam || 'page');
        link.setAttribute('aria-label', 'Go to page ' + page);
        link.textContent = page;
        link.addEventListener('click', function (event) {
          event.preventDefault();
          goToPage(page);
        });
        pagination.appendChild(link);
      }

      function addEllipsis() {
        var ellipsis = document.createElement('span');
        ellipsis.className = 'pagination__item pagination__item--page pagination__item--ellipsis';
        ellipsis.setAttribute('aria-hidden', 'true');
        ellipsis.textContent = '…';
        pagination.appendChild(ellipsis);
      }

      addControl(currentPage - 1, 'previous');

      if (totalPages <= 7) {
        for (var page = 1; page <= totalPages; page += 1) addPage(page);
      } else if (currentPage <= 3) {
        for (var firstPage = 1; firstPage <= 5; firstPage += 1) addPage(firstPage);
        addEllipsis();
        addPage(totalPages);
      } else if (currentPage >= totalPages - 2) {
        addPage(1);
        addEllipsis();
        for (var lastPage = totalPages - 4; lastPage <= totalPages; lastPage += 1) addPage(lastPage);
      } else {
        addPage(1);
        addEllipsis();
        addPage(currentPage - 1);
        addPage(currentPage);
        addPage(currentPage + 1);
        addEllipsis();
        addPage(totalPages);
      }
      addControl(currentPage + 1, 'next');
    }

    function renderDealers() {
      var filtered = cards.filter(function (card) {
        return (!stateSelect.value || stateSelect.value === 'all' || card.dataset.state === stateSelect.value) &&
          (!typeSelect.value || getCardTypes(card).includes(typeSelect.value));
      });
      var totalPages = Math.ceil(filtered.length / pageSize);
      if (currentPage > totalPages) currentPage = totalPages || 1;
      var pageCards = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);
      var fragment = document.createDocumentFragment();
      pageCards.forEach(function (card, index) {
        card.hidden = false;
        card.classList.toggle('is-alt', index % 2 === 1);
        fragment.appendChild(card);
      });
      list.replaceChildren(fragment);
      empty.hidden = filtered.length !== 0;
      renderPagination(totalPages);
    }

    function pageURL(page, parameter) {
      var url = new URL(window.location.href);
      url.searchParams.set(parameter, page);
      url.hash = '';
      return url.toString();
    }

    function loadAllDealerPages() {
      var totalServerPages = Number(pagination.dataset.totalPages || 1);
      var currentServerPage = Number(pagination.dataset.currentPage || 1);
      var pageParameter = pagination.dataset.pageParam || 'page';
      if (totalServerPages <= 1) return Promise.resolve();

      var cardsByPage = {};
      cardsByPage[currentServerPage] = cards;
      var requests = [];
      for (var page = 1; page <= totalServerPages; page += 1) {
        if (page === currentServerPage) continue;
        (function (requestedPage) {
          requests.push(fetch(pageURL(requestedPage, pageParameter), { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) throw new Error('Dealer page could not be loaded');
              return response.text();
            })
            .then(function (html) {
              var documentForPage = new DOMParser().parseFromString(html, 'text/html');
              var sectionForPage = documentForPage.getElementById(root.id);
              if (!sectionForPage) throw new Error('Dealer section could not be found');
              return Array.from(sectionForPage.querySelectorAll('[data-dealer-card]'));
            })
            .then(function (pageCards) {
              cardsByPage[requestedPage] = pageCards;
            }));
        })(page);
      }

      return Promise.all(requests).then(function () {
        cards = [];
        for (var page = 1; page <= totalServerPages; page += 1) {
          cards = cards.concat(cardsByPage[page] || []);
        }
        prepareCards(cards);
        populateDealerTypes();
        currentPage = 1;
        renderDealers();
      }).catch(function (error) {
        if (window.console) console.error(error);
      });
    }

    prepareCards(cards);
    populateDealerTypes();
    renderDealers();
    stateSelect.addEventListener('change', function () {
      currentPage = 1;
      renderDealers();
    });
    typeSelect.addEventListener('change', function () {
      currentPage = 1;
      renderDealers();
    });
    loadAllDealerPages();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-resellers]').forEach(initHowToBuy);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
